import { colors } from '../../../../../../../components/src/theme'

export const customStyles = {
  table: {
    style: { backgroundColor: colors.surface, alignSelf: 'center' },
  },
  tableWrapper: {
    style: {
      backgroundColor: colors.surface,
      width: '100%',
      justifyContent: 'center',
      display: 'flex',
    },
  },
  subHeader: {
    style: {
      paddingBottom: 0,
      flex: 1,
    },
  },
  head: {
    style: {},
  },
  headRow: {
    style: {
      borderBottomWidth: 0,
      minHeight: 35,
    },
    denseStyle: {},
  },
  contextMenu: {
    style: {},
    activeStyle: {},
  },
  cells: {
    style: {
      paddingLeft: 0,
      paddingRight: 0,
      color: colors.primary,
      fontSize: 16,
      lineHeight: 1.5,
      fontWeight: '400',
    },
  },
  rows: {
    selectedHighlightStyle: {},
    denseStyle: {},
    stripedStyle: {},
  },
  expanderRow: {
    style: {},
  },
  expanderCell: {
    style: {},
  },
  expanderButton: {
    style: {},
  },
  pagination: {
    style: {
      width: '90%',
      alignSelf: 'center',
      borderTopWidth: 0,
    },
    pageButtonsStyle: {},
  },
  noData: {
    style: {},
  },
  progress: {
    style: { width: '100%' },
  },
}
